import React, { useState, useEffect } from 'react';

const ParticleNetwork = () => {
    const [particles, setParticles] = useState([]);
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const particleCount = 20;

    useEffect(() => {
        const updateDimensions = () => {
            setDimensions({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        updateDimensions();
        window.addEventListener('resize', updateDimensions);

        const generateParticles = () => {
            const newParticles = [];
            for (let i = 0; i < particleCount; i++) {
                newParticles.push({
                    id: i,
                    x: Math.random() * window.innerWidth,
                    y: Math.random() * window.innerHeight,
                    size: Math.random() * 4 + 2,
                    speedX: (Math.random() - 0.5) * 1,
                    speedY: (Math.random() - 0.5) * 1
                });
            }
            setParticles(newParticles);
        };

        generateParticles();

        return () => {
            window.removeEventListener('resize', updateDimensions);
        };
    }, []);

    useEffect(() => {
        const moveParticles = setInterval(() => {
            setParticles(prevParticles =>
                prevParticles.map(particle => {
                    let newX = particle.x + particle.speedX;
                    let newY = particle.y + particle.speedY;

                    // Bounce off edges
                    if (newX <= 0 || newX >= dimensions.width) {
                        newX = Math.max(0, Math.min(newX, dimensions.width));
                        particle.speedX *= -1;
                    }
                    if (newY <= 0 || newY >= dimensions.height) {
                        newY = Math.max(0, Math.min(newY, dimensions.height));
                        particle.speedY *= -1;
                    }

                    return {
                        ...particle,
                        x: newX,
                        y: newY
                    };
                })
            );
        }, 30);

        return () => clearInterval(moveParticles);
    }, [dimensions]);

    const getDistance = (x1, y1, x2, y2) => {
        return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
    };

    const drawLines = () => {
        const lines = [];
        const maxDistance = 150;

        for (let i = 0; i < particles.length; i++) {
            for (let j = i + 1; j < particles.length; j++) {
                const distance = getDistance(
                    particles[i].x,
                    particles[i].y,
                    particles[j].x,
                    particles[j].y
                );

                if (distance < maxDistance) {
                    const opacity = 1 - (distance / maxDistance);
                    lines.push(
                        <line
                            key={`line-${i}-${j}`}
                            x1={particles[i].x}
                            y1={particles[i].y}
                            x2={particles[j].x}
                            y2={particles[j].y}
                            stroke={`rgba(100, 100, 100, ${opacity * 0.4})`}
                            strokeWidth="1"
                        />
                    );
                }
            }
        }

        return lines;
    };

    return (
        <div className="particle-network">
            <svg width="100%" height="100%">
                {drawLines()}
                {particles.map(particle => (
                    <circle
                        key={particle.id}
                        cx={particle.x}
                        cy={particle.y}
                        r={particle.size}
                        fill="rgba(100, 100, 100, 0.4)"
                    />
                ))}
            </svg>
        </div>
    );
};

export default ParticleNetwork;
